var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataReportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.49748 14.5835V12.0835M9.66415 14.5835V7.0835M13.8308 14.5835V11.2502",
    stroke: "black",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9975 4.5835C17.9975 5.9642 16.8782 7.0835 15.4975 7.0835C14.1167 7.0835 12.9975 5.9642 12.9975 4.5835C12.9975 3.20279 14.1167 2.0835 15.4975 2.0835C16.8782 2.0835 17.9975 3.20279 17.9975 4.5835Z",
    stroke: "black",
    strokeWidth: 1.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9937 9.16683C17.9937 9.16683 17.9975 9.44975 17.9975 10.0002C17.9975 13.7322 17.9975 15.5981 16.8381 16.7575C15.6787 17.9168 13.8127 17.9168 10.0808 17.9168C6.34886 17.9168 4.48288 17.9168 3.32351 16.7575C2.16414 15.5981 2.16414 13.7322 2.16414 10.0002C2.16414 6.26824 2.16414 4.40226 3.32351 3.24289C4.48288 2.08352 6.34886 2.08352 10.0808 2.08352L10.9141 2.0835",
    stroke: "black",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataReportIcon);
export default __webpack_public_path__ + "static/media/data-report-icon.5902e40fc2b4a7a5e41f34b980a9f3c2.svg";
export { ForwardRef as ReactComponent };